import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IAMService } from '../services';

const PERMISSION_CLAIMNAME: string = 'ApplicationLogin';
const PERMISSION_CLAIMVALUE: string = 'PDO';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard implements CanActivate {
  constructor(public router: Router, private iamService: IAMService) {}

  public canActivate(): Observable<boolean> {
    return this.iamService.hasPermission(PERMISSION_CLAIMNAME, PERMISSION_CLAIMVALUE).pipe(
      tap((hasPermission) => {
        if (!hasPermission) {
          this.router.navigate(['forbidden']);
        }
      })
    );
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }
}
